import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardGroup,
  CloseButton,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Loading from "../shared/Loading";
import patientService from "../services/patient.service";
import Address from "../shared/Address";
import { DateFormat, calculateSum } from "../Helper";
import paymentService from "../services/payment.service";
import CommonTree from "../shared/CommonTree";
import { Typeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CollectionSummary from "./CollectionSummary";
import ClientSummary from "./ClientSummary";
import OrderSummary from "./OrderSummary";

const PyamentCollection = () => {
  const { patientId, invoiceId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const formRef = useRef([]);
  const [inv, setInv] = useState();
  const { bp, invoice, user } = { ...inv };
  const [paymentOptions, setPaymentOptions] = useState({
    payers: [],
    tpas: [],
    pmodes: [],
  });
  const [summary, setSummary] = useState({});
  const [collectionFormValidated, setCollectionFormValidated] = useState(false);
  const [pmode, setPmode] = useState([]);
  const [collections, setCollections] = useState([]);
  const [validPayer, setValidPayer] = useState(true);
  const handlePayerChange = (selectedPayerNode) => {
    if (selectedPayerNode.length > 0) {
      var payerNode = selectedPayerNode[0];
      if (payerNode.isLeaf) {
        setValidPayer(true);
        if (payerNode.data.payer_type === "Self") {
          formRef.current.tpa.deselectAll();
          document.getElementById("tpa-card").classList.add("disabled-area");
        } else {
          document.getElementById("tpa-card").classList.remove("disabled-area");
        }
      } else {
        setValidPayer(false);
      }
    }
  };
  const handleNewCollection = async (e) => {
    e.preventDefault();
    let error = false;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      error = true;
    }
    setCollectionFormValidated(true);
    var tpa_id = null;
    if (formRef.current.payer.hasNoSelection) {
      toast.error("Payer is required");
      error = true;
    } else {
      const selectedPayerNode = formRef.current.payer.selectedNodes;
      if (selectedPayerNode.length > 0) {
        var payerNode = selectedPayerNode[0];
        if (payerNode.isLeaf) {
          if (
            payerNode.data.payer_type === "Self" ||
            formRef.current.tpa.hasNoSelection
          ) {
            tpa_id = null;
          } else {
            tpa_id = Array.from(formRef.current.tpa.selectedIds)[0];
          }
        } else {
          toast.error("Payer is required");
          error = true;
        }
      }
    }
    if (error) return;
    const collection = {
      narration: formRef.current.remark.value,
      transaction_date: formRef.current.payment_date.value,
      total_amount: formRef.current.amount.value,
      voucher_type: "Receipt",
      bp_br_service_order_id: invoiceId,
      bp_br_bill_num: invoice.bp_br_bill_num,
      bp_patient_id: user.patient.bp_patient_id,
      kapid_user_id: patientId,
      bp_payment_mode_id: pmode.length > 0 ? pmode[0].bp_payment_mode_id : null,
      payment_transaction_ref_num: formRef.current.referrence.value,
      bp_payer_id: formRef.current.payer.hasNoSelection
        ? null
        : Array.from(formRef.current.payer.selectedIds)[0],
      status: "Valid",
      is_debit: false,
      bp_tpa_id: tpa_id,
    };
    setIsLoading(true);
    const response = await paymentService.createPayment(collection);
    setIsLoading(false);
    if (response !== false) {
      const total_paid = calculateSum(response, "total_amount");

      setSummary({ ...summary, paid: total_paid });
      setCollections([...response]);
      form.reset();
      setPmode([]);
      // formRef.current.payer.deselectAll();
      // formRef.current.tpa.deselectAll();
      setCollectionFormValidated(false);
      toast.success("Collection added successfully");
    }
  };
  const fetchData = async () => {
    try {
      const invoice = await patientService.getInvoice(patientId, invoiceId);

      const payers = await paymentService.getPayers();
      const tpas = await paymentService.getTpas();
      const pmodes = await paymentService.getPaymentModes();
      setPaymentOptions({ payers, tpas, pmodes });
      setInv(invoice);
      if (invoice.invoice.collections) {
        setCollections([...invoice.invoice.collections]);
      }

      setSummary({ ...invoice.invoice });
      setIsLoading(false);
    } catch (error) {
      setIsLoading("error");
      console.log(error);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchData();
    return () => {
      setIsLoading(false);
    };
  }, []);

  if (isLoading === true) {
    return <Loading />;
  } else if (isLoading === "error") {
    return <Loading failed={true} />;
  }

  return (
    <Container className="pt-3 pc-container">
      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <ClientSummary {...inv} />

              <OrderSummary summary={summary} />
              <div className="py-2">
                <CollectionSummary collections={collections} />
              </div>

              <Form
                noValidate
                validated={collectionFormValidated}
                onSubmit={handleNewCollection}
                className="d-print-none"
              >
                <hr className="my-4" />
                <div className="py-2">
                  <h5 className="font-size-15">New Collection</h5>
                  <CardGroup className="my-3">
                    <Card body border={validPayer ? "" : "danger"}>
                      <h3>Payer</h3>
                      <CommonTree
                        data={paymentOptions.payers}
                        childrenAccessor="payer_details"
                        ref={(el) => (formRef.current["payer"] = el)}
                        onSelect={(nodes) => handlePayerChange(nodes)}
                      />
                    </Card>
                    <Card body id="tpa-card">
                      {/* <CloseButton className="float-end" /> */}
                      <h3>TPA</h3>
                      <CommonTree
                        data={paymentOptions.tpas}
                        //   childrenAccessor="payer_details"
                        ref={(el) => (formRef.current["tpa"] = el)}
                      />
                    </Card>
                    <Card body>
                      <Form.Group className="mb-3">
                        <Form.Label>Payment Mode</Form.Label>
                        <Typeahead
                          options={paymentOptions.pmodes}
                          placeholder="Select a payment mode"
                          id="payment-mode"
                          labelKey={"display_name"}
                          multiple={false}
                          onChange={(selected) => {
                            setPmode(selected);
                          }}
                          selected={pmode}
                          inputProps={{ required: true }}
                          filterBy={() => true}
                        ></Typeahead>
                      </Form.Group>
                      <div className="mb-3">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control
                          type="number"
                          min={1}
                          required
                          ref={(el) => (formRef.current["amount"] = el)}
                        />
                      </div>
                      <div className="mb-3">
                        <Form.Label>Date</Form.Label>
                        <Form.Control
                          type="date"
                          required
                          defaultValue={new Date().toISOString().split("T")[0]}
                          ref={(el) => (formRef.current["payment_date"] = el)}
                        />
                      </div>
                      <div className="mb-3">
                        <Form.Label>Reference</Form.Label>
                        <Form.Control
                          className="user-select-all"
                          type="text"
                          ref={(el) => (formRef.current["referrence"] = el)}
                        />
                      </div>
                    </Card>
                  </CardGroup>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control
                      as={"textarea"}
                      rows={3}
                      ref={(el) => (formRef.current["remark"] = el)}
                    />
                  </Form.Group>
                  <Link
                    to={`/patient/${patientId}/invoice/${invoice.bp_service_order_base_id}`}
                    target="_blank"
                    className="btn btn-info"
                    rel="noopener noreferrer"
                  >
                    Invoice{" "}
                    <FontAwesomeIcon icon="fa-solid fa-arrow-up-right-from-square" />
                  </Link>
                  <button className="btn btn-primary float-end" type="submit">
                    Save
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PyamentCollection;
